exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".group-add-row[data-v-028acd1f]{top:148px}.concept-hr[data-v-028acd1f]{position:absolute;bottom:0;left:0;right:0}", ""]);

